import { $Keys } from 'utility-types'

import {
  IField_Storage_Type,
  IField_Storage_Type_Public,
  IField_Storage_Type_Private,
  IField_Filestore_Type,
  IField_Filestore_Type_Private,
  IField_Filestore_Type_Public,
  IField_Filestore_Type_Shared,
  IField_Filestore_Type_Drive_Public,
  IField_Filestore_Type_Drive_Private,
  IField_Storage_Location,
  IField_Storage_Access_Type_Private,
  IField_Storage_Access_Type_Shared,
  IField_Storage_Access_Type_Public,
  IField_Storage_Access_Type,
} from '../types/storage'

/*

  storage

*/

export const STORAGE_ACCESS_TYPE_PRIVATE: IField_Storage_Access_Type_Private = 'private'
export const STORAGE_ACCESS_TYPE_SHARED: IField_Storage_Access_Type_Shared = 'shared'
export const STORAGE_ACCESS_TYPE_PUBLIC: IField_Storage_Access_Type_Public = 'public'

// The R2 custom domain public files are served from. Env-driven for other
// deployments; the GCS bucket that served them until 2026-10-17 is going away.
export const STORAGE_BUCKET_PUBLIC_URL = process.env.STORAGE_BUCKET_PUBLIC_URL || 'https://storage.franchisecloud.io'
// Where public files lived on GCP. Saved file urls, search documents and old
// layouts may still carry it; StorageFile.url() maps it onto the R2 domain.
export const LEGACY_STORAGE_BUCKET_PUBLIC_URL = 'https://storage.googleapis.com/www.storage.franchisecloud.io'
export const STORAGE_BUCKET_NAME_PUBLIC = 'www.storage.franchisecloud.io'
export const STORAGE_BUCKET_NAME_PRIVATE = 'franchisecloud-private-storage'
export const STORAGE_BUCKET_PREFIX = process.env.GOOGLE_STORAGE_BUCKET_PREFIX

export const STORAGE_TYPE_PUBLIC: IField_Storage_Type_Public = 'public'
export const STORAGE_TYPE_PRIVATE: IField_Storage_Type_Private = 'private'

export const STORAGE_TYPES = [
  STORAGE_TYPE_PUBLIC,
  STORAGE_TYPE_PRIVATE,
]

export const STORAGE_BUCKET_NAMES: Record<IField_Storage_Type, string> = {
  public: STORAGE_BUCKET_NAME_PUBLIC,
  private: STORAGE_BUCKET_NAME_PRIVATE,
}

export const FILESTORE_TYPE_PRIVATE: IField_Filestore_Type_Private = 'private'
export const FILESTORE_TYPE_PUBLIC: IField_Filestore_Type_Public = 'public'
export const FILESTORE_TYPE_SHARED: IField_Filestore_Type_Shared = 'shared'
export const FILESTORE_TYPE_DRIVE_PUBLIC: IField_Filestore_Type_Drive_Public = 'drive_public'
export const FILESTORE_TYPE_DRIVE_PRIVATE: IField_Filestore_Type_Drive_Private = 'drive_private'

export const FILESTORE_TYPES = [
  FILESTORE_TYPE_PRIVATE,
  FILESTORE_TYPE_PUBLIC,
  FILESTORE_TYPE_SHARED,
  FILESTORE_TYPE_DRIVE_PUBLIC,
  FILESTORE_TYPE_DRIVE_PRIVATE,
]

export const FILESTORE_ACCESS_TYPES: Record<IField_Filestore_Type, IField_Storage_Access_Type> = {
  [FILESTORE_TYPE_PRIVATE]: STORAGE_ACCESS_TYPE_PRIVATE,
  [FILESTORE_TYPE_PUBLIC]: STORAGE_ACCESS_TYPE_PUBLIC,
  [FILESTORE_TYPE_SHARED]: STORAGE_ACCESS_TYPE_SHARED,
  [FILESTORE_TYPE_DRIVE_PUBLIC]: STORAGE_ACCESS_TYPE_PUBLIC,
  [FILESTORE_TYPE_DRIVE_PRIVATE]: STORAGE_ACCESS_TYPE_PRIVATE
}

// lower number means more private
export const FILESTORE_ACCESS_TYPE_SCORES: Record<IField_Storage_Access_Type, number> = {
  [STORAGE_ACCESS_TYPE_PRIVATE]: 0,
  [STORAGE_ACCESS_TYPE_SHARED]: 10,
  [STORAGE_ACCESS_TYPE_PUBLIC]: 20,
}

export const FILESTORE_STORAGE_TYPES: Record<IField_Filestore_Type, IField_Storage_Type> = {
  [FILESTORE_TYPE_PRIVATE]: STORAGE_TYPE_PRIVATE,
  [FILESTORE_TYPE_PUBLIC]: STORAGE_TYPE_PUBLIC,
  [FILESTORE_TYPE_SHARED]: STORAGE_TYPE_PRIVATE,
  [FILESTORE_TYPE_DRIVE_PUBLIC]: STORAGE_TYPE_PUBLIC,
  [FILESTORE_TYPE_DRIVE_PRIVATE]: STORAGE_TYPE_PRIVATE
}

export const FILESTORE_ROLES: Record<IField_Filestore_Type, string> = {
  [FILESTORE_TYPE_PRIVATE]: 'storage:filestore_writer',
  [FILESTORE_TYPE_PUBLIC]: 'storage:filestore_writer',
  [FILESTORE_TYPE_SHARED]: 'storage:admin',
  [FILESTORE_TYPE_DRIVE_PUBLIC]: 'storage:filestore_writer',
  [FILESTORE_TYPE_DRIVE_PRIVATE]: 'storage:filestore_writer'
}

export const FILESTORE_TITLES: Record<IField_Filestore_Type, string> = {
  [FILESTORE_TYPE_PRIVATE]: 'Private Files',
  [FILESTORE_TYPE_SHARED]: 'Shared Files',
  [FILESTORE_TYPE_PUBLIC]: 'Public Files',
  [FILESTORE_TYPE_DRIVE_PUBLIC]: 'Public System Files',
  [FILESTORE_TYPE_DRIVE_PRIVATE]: 'Private System Files', 
}

export const STORAGE_LOCATION_CRM_IMPORT: IField_Storage_Location = {
  type: FILESTORE_TYPE_PRIVATE,
  path: 'crm/imports'
}

export const STORAGE_LOCATION_RBAC_PROFILE: IField_Storage_Location = {
  type: FILESTORE_TYPE_PUBLIC,
  path: 'rbac/profile'
}

export const STORAGE_LOCATION_ASTONISH_TEMPLATE_SCREENSHOT: IField_Storage_Location = {
  type: FILESTORE_TYPE_DRIVE_PUBLIC,
  path: 'astonish/template/screenshot'
}

export const STORAGE_LOCATION_ASTONISH_CAMPAIGN_SCREENSHOT: IField_Storage_Location = {
  type: FILESTORE_TYPE_DRIVE_PUBLIC,
  path: 'astonish/campaign/screenshot'
}

export const STORAGE_LOCATION_KNOWLEDGEBASE_ARTICLE_SCREENSHOT: IField_Storage_Location = {
  type: FILESTORE_TYPE_DRIVE_PUBLIC,
  path: 'knowledgebase/article/screenshot'
}

export const STORAGE_LOCATION_NOPRESS_PUBLISH: IField_Storage_Location = {
  type: FILESTORE_TYPE_DRIVE_PUBLIC,
  path: 'nopress/publish'
}

export const STORAGE_LOCATION_NOPRESS_UPLOAD: IField_Storage_Location = {
  type: FILESTORE_TYPE_PUBLIC,
  path: 'nopress/upload'
}

export const STORAGE_LOCATION_PROJECT_SETTINGS: IField_Storage_Location = {
  type: FILESTORE_TYPE_PUBLIC,
  path: 'project/settings'
}

export const STORAGE_LOCATION_MARKETING_POSTS: IField_Storage_Location = {
  type: FILESTORE_TYPE_PUBLIC,
  path: 'marketing/posts'
}

export const STORAGE_LOCATIONS: Record<any, IField_Storage_Location> = {
  crm_import: STORAGE_LOCATION_CRM_IMPORT,
  rbac_profile: STORAGE_LOCATION_RBAC_PROFILE,
  astonish_template_screenshot: STORAGE_LOCATION_ASTONISH_TEMPLATE_SCREENSHOT,
  astonish_campaign_screenshot: STORAGE_LOCATION_ASTONISH_CAMPAIGN_SCREENSHOT,
  knowledgebase_article_screenshot: STORAGE_LOCATION_KNOWLEDGEBASE_ARTICLE_SCREENSHOT,
  nopress_publish: STORAGE_LOCATION_NOPRESS_PUBLISH,
  nopress_upload: STORAGE_LOCATION_NOPRESS_UPLOAD,
  project_settings: STORAGE_LOCATION_PROJECT_SETTINGS,
  marketing_posts: STORAGE_LOCATION_MARKETING_POSTS,
}

export type IStorageLocationName = $Keys<typeof STORAGE_LOCATIONS>